import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const flowLanguagesActions = createActions({
    FLOW_GET_LANGUAGES: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
}, 'FLOW_GET_LANGUAGES_SUCCEEDED', 'FLOW_GET_LANGUAGES_FAILED');
